import React, { useState } from "react"

import { useParams } from "react-router-dom"
import { gql, useQuery } from "urql"

import { Button, Heading, Text } from "@chakra-ui/core"

import Paginator from "~tailwindui/Table/Paginator"

import Layer from "components/Pages/Layer"
import ErrorBoundary from "components/Pages/Teacher/ErrorBoundary"
import Wrapper from "components/Pages/Teacher/Table/Wrapper"
import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

import AcrClassPeriodTableRow from "./AcrClassPeriodTableRow"

const AirClassroomDetailsPage = () => {
  const { id } = useParams<{ id: string }>()
  const [page, setPage] = useState(1)
  const [upcoming, setUpcoming] = useState(false)
  const [result] = useQuery({
    query: acrClassQuery,
    variables: { id, page, upcoming },
  })

  const toggleUpcoming = () => {
    setUpcoming(!upcoming)
    setPage(1)
  }

  return (
    <>
      <UrqlLoadingIndicator result={result}>
        {({ data }) => (
          <>
            <Layer>
              <ErrorBoundary name="AirClassroomDetails">
                <Heading fontSize="3xl" isTruncated>
                  {data.acrClass.name}
                </Heading>
                <Text fontSize="lg">{data.acrClass.subject.name}</Text>
              </ErrorBoundary>
            </Layer>

            <Layer>
              <ErrorBoundary name="acrClassPeriodsTable">
                <Button
                  onClick={toggleUpcoming}
                  position="absolute"
                  right={["4", "4", "12"]}
                  variant="outline"
                  variantColor="blue"
                  color="blue.700"
                >
                  {upcoming ? "Past Periods" : "Upcoming Periods"}
                </Button>
                <Wrapper
                  title={upcoming ? "Upcoming Periods" : "Past Periods"}
                  rowComponent={AcrClassPeriodTableRow}
                  data={data.acrClass.paginatedAcrClassPeriods.data}
                  filters={[]}
                  columns={[
                    {
                      title: "Time",
                      width: "50%",
                      isOrderable: false,
                      isFilterable: false,
                    },
                    {
                      title: "Date",
                      width: "50%",
                      isOrderable: false,
                      isFilterable: false,
                    },
                  ]}
                />
                <Paginator
                  currentPage={
                    data.acrClass.paginatedAcrClassPeriods.currentPage
                  }
                  totalPages={data.acrClass.paginatedAcrClassPeriods.totalPages}
                  changePage={setPage}
                />
              </ErrorBoundary>
            </Layer>
          </>
        )}
      </UrqlLoadingIndicator>
    </>
  )
}

const acrClassQuery = gql`
  query TeacherAirClassroomDetails($id: ID!, $page: Int, $upcoming: Boolean!) {
    acrClass(id: $id) {
      id
      name
      subject {
        id
        name
      }
      paginatedAcrClassPeriods(page: $page, upcoming: $upcoming) {
        currentPage
        totalPages
        data {
          id
          startsAt
          endsAt
        }
      }
    }
  }
`

export default AirClassroomDetailsPage
